import React from 'react';
interface LogoProps {
  size?: number;
  className?: string;
}
// Official Moceri Residential Services logo
export function Logo({
  size = 80,
  className = ''
}: LogoProps) {
  return <img src="https://assets.cdn.filesafe.space/RMzNb2TUk9Xj1mj8RDD5/media/697c9cc3-8886-4ed8-b337-7a9654dfead4.png" alt="Moceri Residential Services" width={size} height={size} className={className} style={{
    width: size,
    height: size,
    objectFit: 'contain'
  }} data-id="element-190" data-mp="3q9us6pm0hftn" />;
}